// Auto-generated build information - do not edit manually
// Generated at: 2026-10-16T15:12:01.397Z

export const buildInfo = {
  "buildNumber": "2201792163521396",
  "buildDate": "2026-10-16T15:12:01.396Z",
  "gitCommit": "275a2b2",
  "gitBranch": "dev",
  "gitTag": null,
  "environment": "dev"
} as const;

export type BuildInfo = typeof buildInfo;
